var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-s-a-w index"},[_c('Swiper',{attrs:{"shouyecode":_vm.shouyecode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }